// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import AbstractAnimationChannel from '../../animationpack/clip/AbstractAnimationChannel';
import TriggerData from '../../animationpack/clip/TriggerData';

/**
 * An animation source channel consisting of keyword samples indicating when a specific trigger condition is met. Each channel can only be in one keyword "state" at a given moment in time.
 * @param {string} channelName the name of this channel.
 * @param {Array<number>} times the time samples
 * @param {Array<string>} keys our key samples. Entries may be null. Should have as many entries as the times array.
 * @param {string} blendType
 */
class TriggerChannel extends AbstractAnimationChannel {
  constructor(channelName, times, keys, blendType) {
    super(channelName, times, blendType);
    this._keys = keys ? keys.slice(0) : null;
    this.guarantee = false;
  }

  /**
   * Creates a data item for this type of channel
   * @returns {TriggerData}
   */
  createStateDataObject() {
    return new TriggerData();
  }

  /**
   * Applies the channels animation state to supplied data item
   * @param {number} sampleIndex
   * @param {number} progressPercent
   * @param {TriggerData} triggerData value The data item to apply animation to
   */
  setCurrentSample(sampleIndex, progressPercent, triggerData) {
    let oldIndex = triggerData._currentIndex;

    const newIndex = progressPercent !== 1.0 ? sampleIndex : sampleIndex + 1;

    if (oldIndex === newIndex || !this.guarantee) {
      triggerData.arm(newIndex, [this._keys[newIndex]]);
    } else {
      const triggers = [];
      if (oldIndex > newIndex) {
        for (var i = oldIndex + 1; i < this._keys.length; i++) {
          triggers.push(this._keys[i]);
        }
        oldIndex = -1;
      }
      for (var i = oldIndex + 1; i <= newIndex; i++) {
        triggers.push(this._keys[i]);
      }
      triggerData.arm(newIndex, triggers);
    }
  }
}

export default TriggerChannel;
